import {
  CFormCheck,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useQueryClient, useMutation } from "react-query";
import { useToast } from "../../../hooks/useToast";
import { useCookie } from "../../../hooks/useCookie";
import apiService from "../../../service/apiService";
import { DELETE_ACTIONS } from "../../../config/constants";
import { general } from "../../../locales/general";
import { colors } from "../../../config/theme";
import EditIcon from "../../../components/icons/EditIcon";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import PromptModal from "../../../components/modals/PromptModal";
import { Link } from "react-router-dom";

function TableBodyRowContent({
  serviceTranslation,
  deletedList,
}: {
  serviceTranslation: ServiceTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteServiceTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`service-translations/${id}`, token);
  });

  useEffect(() => {
    if (isChecked) {
      deletedList({ type: DELETE_ACTIONS.ADD, id: serviceTranslation.id });
    } else {
      deletedList({ type: DELETE_ACTIONS.REMOVE, id: serviceTranslation.id });
    }
  }, [deletedList, isChecked, serviceTranslation.id]);

  const removeServiceTranslation = () => {
    deleteServiceTranslation.mutate(serviceTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <CTableRow
      style={{
        borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className=" text-capitalize text-sm">
        <div className="d-flex align-items-center gap-3">
          <CFormCheck
            id="flexCheckDefault"
            label=""
            defaultChecked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            color={colors.yellow}
          />

          <div>{serviceTranslation.service?.label}</div>
        </div>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{serviceTranslation?.label}</span>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{serviceTranslation?.lang}</span>
      </CTableDataCell>

      <CTableDataCell>
        <Link to={`/service-translations/update/${serviceTranslation.id}`}>
          <EditIcon width="18" height="18" fill={colors.secondary} />
        </Link>{" "}
        <button
          className="outline-none border-0 bg-transparent"
          onClick={() => setShowModal(true)}
        >
          {deleteServiceTranslation.isLoading ? (
            <CSpinner size="sm" />
          ) : (
            <DeleteIcon
              width="20"
              height="20"
              fill={colors.primary}
              className="ms-2"
            />
          )}
        </button>
      </CTableDataCell>
      <PromptModal
        open={showModal}
        onAccept={removeServiceTranslation}
        onClose={() => setShowModal(false)}
      />
      {/* <ServiceTranslationModal
                onClose={() => setShowEditModal(false)}
                open={showEditModal}
                id={serviceTranslation?.id}
                name={serviceTranslation?.name}
                link={serviceTranslation?.link}
                logo={serviceTranslation?.logoImage}
            /> */}
    </CTableRow>
  );
}

interface TableProps {
  serviceTranslations: ServiceTranslation[];
  serviceTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function ServiceTranslationsTable({
  serviceTranslations,
  serviceTranslationsToBeDeleted,
}: TableProps) {
  return (
    <div className="mt-3">
      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Service</CTableHeaderCell>
            <CTableHeaderCell scope="col">Traduction</CTableHeaderCell>
            <CTableHeaderCell scope="col">Langue</CTableHeaderCell>
            <CTableHeaderCell scope="col"></CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {serviceTranslations?.map((serviceTranslation) => (
            <TableBodyRowContent
              serviceTranslation={serviceTranslation}
              key={serviceTranslation?.id}
              deletedList={serviceTranslationsToBeDeleted}
            />
          ))}{" "}
        </CTableBody>
      </CTable>
    </div>
  );
}
